import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { getZonedEndOfDay, getZonedStartOfDay } from 'shared/mui/DatePicker/utils/getZonedTime';
import { formatInputToTimestamp } from 'utils/date';

export function getFilterDefaultValues() {
  const today = new Date();

  return {
    createdAt: {
      gte: formatInputToTimestamp(getZonedStartOfDay(today, DEFAULT_TIMEZONE), {
        unit: 'seconds',
      }),
      lte: formatInputToTimestamp(getZonedEndOfDay(today, DEFAULT_TIMEZONE), { unit: 'seconds' }),
    },
    timezone: DEFAULT_TIMEZONE,
  };
}
